import Vue from "vue";
import Vuex from "vuex";

import menus from "./menu";
import tabs from "./tabs";
import language from "./language";

// const api =
//   process.env.NODE_ENV === "production"
//     ? "/api/"
//     : "http://shadow.caa.edu.cn/api/";

const api = "//shadow.caa.edu.cn/api/";

const apiUrl = api;
const dataApi =
  process.env.NODE_ENV === "production" ? "/" : "//shadow.caa.edu.cn/";

Vue.use(Vuex);
const state = {
  locale: "",
  language,
  uploadPath: dataApi.slice(0, -1),
  showMenu: false,
  audio: {
    playing: false,
    inQueue: false,
    src: ""
  },
  menus,
  tabs,
  home: {},
  ysts: {},
  qyfz: {},
  pyms: {},
  pygn: {},
  dfts: {},
  pyzz: {},
  pyby: {},
  gczp: {},
  yjzx: {},
  about: {},
  // 皮影延展
  extension: {},
  // 音乐列表
  audioQueue: [],
  // 老唱机
  "audio-record": {
    searchres: {}
  },
  // 皮影珍藏
  picture: {
    searchres: {}
  },
  // 皮影道具
  prop: {
    searchres: {}
  },
  // 影卷珍藏
  "video-record": {
    searchres: {}
  },
  // 开场锣鼓
  "opening-programme": {
    searchres: {}
  },
  // 皮影文献
  literature: {
    searchres: {}
  },
  // 口述史
  history: {
    searchres: {}
  },
  // 机构人物
  organization: {
    searchres: {}
  },
  // 影戏馆
  programme: {
    searchres: {}
  },
  // 学术报告
  report: {
    searchres: {}
  },
  // 档案馆
  archive: {
    searchres: {}
  }
};

const getters = {
  lngQuery: state => {
    return `?__language=${state.locale}`;
  },
  lngClass: state => {
    if (state.locale != "jp" && state.locale != "ko" && state.locale != "") {
      return "lng";
    }
  }
};

const mutations = {
  changeMenu(state, val) {
    state.showMenu = val;
  },
  setContent(state, { page, tab, data }) {
    Vue.set(state[page], tab, data);
  },
  setDataList(state, { data_name, data }) {
    state[data_name] = {
      ...state[data_name],
      ...data
    };
  },
  setSearchData(state, { data_name, data }) {
    Vue.set(state[data_name], "searchres", data);
  },
  setAudio(state, audio) {
    state.audio = {
      ...state.audio,
      ...audio
    };
  },
  setAudioQueue(state, data) {
    const queue = data.map(v => {
      return v.path;
    });
    state.audioQueue = queue;
  },
  setLocale(state, lng) {
    state.locale = lng === "zh_cn" ? "" : lng;
  }
};

const actions = {
  getContent({ getters, commit }, { page, tab }) {
    // if (state[page][tab]) {
    //   return;
    // }
    const url = `${apiUrl}${page}.${tab}.json${getters.lngQuery}`;
    Vue.axios.get(url).then(res => {
      commit("setContent", {
        page,
        tab,
        data: res.data
      });
    });
  },

  async getSubContent({ getters, commit }, { page, tab, subtab }) {
    // 拼接请求URL数组
    let urls = [];
    for (let i of Array(subtab).keys()) {
      urls.push(`${apiUrl}${page}.${tab}.${i}.json${getters.lngQuery}`);
    }

    // 并发读取远程URL
    const subDatas = urls.map(async url => {
      const res = await Vue.axios.get(url);
      return res.data.content;
    });

    let data = [];
    // 按次序输出
    for (const subData of subDatas) {
      data.push(await subData);
    }

    if (data.length === subtab) {
      commit("setContent", {
        page,
        tab,
        data
      });
    }
  },

  getDataList(
    { state, commit },
    { data_name, page_num = 0, page_size = 12, unpaged = false }
  ) {
    if (state[data_name][page_num]) {
      commit("setDataList", {
        data_name,
        data: {
          number: page_num
        }
      });
      return;
    }

    const query = () => {
      const page = `hidden=false&page=${page_num}&unpaged=${unpaged}&order-by=sort&order-by=id`;
      const size = page_size != 12 ? "page-size=" + page_size : "";
      return size ? `${page}&${size}` : page;
    };

    const url = query()
      ? `${apiUrl}${data_name}.json?${query()}`
      : `${apiUrl}${data_name}.json`;

    Vue.axios.get(url).then(res => {
      if (res.status === 200) {
        const data = {
          size: res.data.size,
          number: res.data.number,
          total_elements: res.data.total_elements,
          total_pages: res.data.total_pages
        };
        data[page_num] = unpaged
          ? res.data.content.reverse()
          : res.data.content;
        commit("setDataList", {
          data_name,
          data
        });
      }
    });
  },

  getExtension(
    { state, commit },
    { category, page_num = 0, page_size = 12, unpaged = false }
  ){
    const query = [
      "hidden=false",
      `page=${page_num}`,
      `unpaged=${unpaged}`,
      "order-by=sort",
      "order-by=id",
      `page-size=${page_size}`,
      `category=${category}`
    ].join("&");

    const url = `${apiUrl}extension.json?${query}`;

    Vue.axios.get(url).then(res => {
      if (res.status === 200) {
        const data = {
          size: res.data.size,
          number: res.data.number,
          total_elements: res.data.total_elements,
          total_pages: res.data.total_pages
        };
        data[page_num] = res.data.content;
        commit("setDataList", {
          data_name: "extension",
          data
        });
      }
    });
  },

  getAllDataList({ commit, dispatch }, data_name) {
    return new Promise((resolve, reject) => {
      const url = `${apiUrl}${data_name}.json?page-size=100`;
      Vue.axios
        .get(url)
        .then(res => {
          if (res.status === 200) {
            const pages = res.data.total_pages;

            let urls = [];
            for (const i of Array(pages).keys()) {
              urls.push(
                `${apiUrl}${data_name}.json?page-size=100&page=${i}&order-by=sort&order-by=id`
              );
            }
            return dispatch("serializeDatas", urls);
          }
        })
        .then(res => {
          const data = { 0: res };
          commit("setDataList", { data_name, data });
          setTimeout(() => {
            resolve();
          }, 500)
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // 序列化分页请求数据
  async serializeDatas({ commit }, urls) {
    const dataPromises = urls.map(async url => {
      const res = await Vue.axios.get(url);
      return res.data.content;
    })
    let dataList = []
    for (let data of dataPromises) {
      dataList = dataList.concat(await data);
    }
    return dataList;
  },

  searchData(
    { commit },
    { data_name, page_num = 0, unpaged = false, ...params }
  ) {
    const query = () => {
      const page = `hidden=false&page=${page_num}&order-by=sort&order-by=id&unpaged=${unpaged}`;
      let search = "";
      for (let key of Object.keys(params)) {
        search += `&${key}=*${encodeURIComponent(params[key])}*`;
      }
      return page + search;
    };

    const url = `${apiUrl}${data_name}.json?${query()}`;

    Vue.axios.get(url).then(res => {
      if (res.status === 200) {
        commit("setSearchData", {
          data_name,
          data: res.data
        });
      }
    });
  },

  getAudioQueue({ commit }) {
    const url = `${apiUrl}audio-record.json?unpaged=true&keywords=1`;
    Vue.axios.get(url).then(res => {
      if (res.status === 200) {
        commit("setAudioQueue", res.data.content);
      }
    });
  },

  changeLocale({ commit }, lng) {
    localStorage.setItem("lng", lng);
    commit("setLocale", lng);
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
